"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _functions = require("../../../../@functions");
var _apis = require("../../../../@apis");
var _hooks = require("../../../../@hooks");
var _TextInput = _interopRequireDefault(require("../../../../@custom/TextInput"));
var _SimpleButton = _interopRequireDefault(require("../../../../@custom/SimpleButton"));
var _Icon = _interopRequireDefault(require("../../../../@custom/Icon"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/**
 * @typedef StepProps
 * @type {import("./index.jsx").StepProps}
 */

/**
 * @param {StepProps} props
 */

function AdminAccount(props) {
  var _errorMsgs$firstName, _errorMsgs$lastName, _errorMsgs$email, _errorMsgs$phone;
  var user = props.user,
    updateUser = props.updateUser,
    goBack = props.goBack,
    goNext = props.goNext;
  var _useErrors = (0, _hooks.useErrors)(),
    errorMsgs = _useErrors.errorMsgs,
    addErrorMsg = _useErrors.addErrorMsg,
    removeErrorMsg = _useErrors.removeErrorMsg;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    acceptedTerms = _useState2[0],
    setAcceptedTerms = _useState2[1];
  var isFormsCompleted = user.phone != '' && user.email != '' && user.firstName != '' && user.email != '';

  /**
   * @param {string} prop
   * @param {any} value
   **/
  var validateUpdate = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(prop, value) {
      var _yield$appcenterApi$u, emailAlreadyTaken, phone;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!(prop === 'firstName')) {
              _context.next = 7;
              break;
            }
            if (value) {
              _context.next = 6;
              break;
            }
            addErrorMsg('firstName', 'first-name-missing');
            return _context.abrupt("return", false);
          case 6:
            removeErrorMsg('firstName', 'first-name-missing');
          case 7:
            if (!(prop === 'lastName')) {
              _context.next = 14;
              break;
            }
            if (value) {
              _context.next = 13;
              break;
            }
            addErrorMsg('lastName', 'last-name-missing');
            return _context.abrupt("return", false);
          case 13:
            removeErrorMsg('lastName', 'last-name-missing');
          case 14:
            if (!(prop === 'email')) {
              _context.next = 33;
              break;
            }
            if (_functions.validator.email(value)) {
              _context.next = 21;
              break;
            }
            removeErrorMsg('email', 'email-already-taken');
            addErrorMsg('email', 'invalid-email');
            return _context.abrupt("return", false);
          case 21:
            removeErrorMsg('email', 'invalid-email');
            _context.next = 24;
            return _apis.appcenterApi.user.exists(value);
          case 24:
            _yield$appcenterApi$u = _context.sent;
            emailAlreadyTaken = _yield$appcenterApi$u.data;
            if (!emailAlreadyTaken) {
              _context.next = 31;
              break;
            }
            addErrorMsg('email', 'email-already-taken');
            return _context.abrupt("return", false);
          case 31:
            removeErrorMsg('email', 'email-already-taken');
            return _context.abrupt("return", true);
          case 33:
            if (!(prop === 'phone')) {
              _context.next = 41;
              break;
            }
            phone = value.replace(/\D/g, '');
            if (!(phone.length < 11)) {
              _context.next = 40;
              break;
            }
            addErrorMsg('phone', 'invalid-phone');
            return _context.abrupt("return", false);
          case 40:
            removeErrorMsg('phone', 'invalid-phone');
          case 41:
            return _context.abrupt("return", true);
          case 42:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function validateUpdate(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
  var validateUser = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
      var isValid, _i, _Object$entries, _Object$entries$_i, prop, value;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            isValid = true;
            _i = 0, _Object$entries = Object.entries(user);
          case 2:
            if (!(_i < _Object$entries.length)) {
              _context2.next = 12;
              break;
            }
            _Object$entries$_i = (0, _slicedToArray2["default"])(_Object$entries[_i], 2), prop = _Object$entries$_i[0], value = _Object$entries$_i[1];
            _context2.next = 6;
            return validateUpdate(prop, value);
          case 6:
            if (_context2.sent) {
              _context2.next = 9;
              break;
            }
            isValid = false;
            return _context2.abrupt("break", 12);
          case 9:
            _i++;
            _context2.next = 2;
            break;
          case 12:
            return _context2.abrupt("return", isValid);
          case 13:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function validateUser() {
      return _ref2.apply(this, arguments);
    };
  }();

  /**
   * @param {string} prop
   * @returns {(evt: React.ChangeEvent<HTMLInputElement>) => Promise<void>}
   **/
  var handleUpdateUser = function handleUpdateUser(prop) {
    return /*#__PURE__*/function () {
      var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(evt) {
        var value;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              value = evt.target.value;
              updateUser((0, _defineProperty2["default"])({}, prop, value));
              validateUpdate(prop, value);
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return function (_x3) {
        return _ref3.apply(this, arguments);
      };
    }();
  };
  var handleCreateAccount = /*#__PURE__*/function () {
    var _ref4 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4() {
      var isValid;
      return _regenerator["default"].wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return validateUser();
          case 2:
            isValid = _context4.sent;
            if (isValid) {
              _context4.next = 5;
              break;
            }
            return _context4.abrupt("return");
          case 5:
            goNext(_objectSpread({}, user));
          case 6:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return function handleCreateAccount() {
      return _ref4.apply(this, arguments);
    };
  }();
  var handleValidForm = /*#__PURE__*/function () {
    var _ref5 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5() {
      var isValid;
      return _regenerator["default"].wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return validateUser();
          case 2:
            isValid = _context5.sent;
            if (isValid) {
              _context5.next = 5;
              break;
            }
            return _context5.abrupt("return");
          case 5:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return function handleValidForm() {
      return _ref5.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", {
    className: "Auth-right-form-link",
    onClick: goBack
  }, "\xAB Voltar"), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement(_material.FormGroup, {
    row: true
  }, /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
    label: "Primeiro nome",
    onChange: handleUpdateUser('firstName'),
    value: user.firstName
  }), /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
    label: "\xDAltimo nome",
    onChange: handleUpdateUser('lastName'),
    value: user.lastName
  })), ((_errorMsgs$firstName = errorMsgs.firstName) === null || _errorMsgs$firstName === void 0 ? void 0 : _errorMsgs$firstName.length) > 0 && errorMsgs.firstName.map(function (msg) {
    return /*#__PURE__*/_react["default"].createElement("p", {
      key: msg,
      className: "Auth-right-form-error"
    }, "* ", errors[msg]);
  }), ((_errorMsgs$lastName = errorMsgs.lastName) === null || _errorMsgs$lastName === void 0 ? void 0 : _errorMsgs$lastName.length) > 0 && errorMsgs.lastName.map(function (msg) {
    return /*#__PURE__*/_react["default"].createElement("p", {
      key: msg,
      className: "Auth-right-form-error"
    }, "* ", errors[msg]);
  }), /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
    label: "Email",
    placeholder: "exemplo@gmail.com",
    onChange: handleUpdateUser('email'),
    value: user.email
  }), ((_errorMsgs$email = errorMsgs.email) === null || _errorMsgs$email === void 0 ? void 0 : _errorMsgs$email.length) > 0 && errorMsgs.email.map(function (msg) {
    return /*#__PURE__*/_react["default"].createElement("p", {
      key: msg,
      className: "Auth-right-form-error"
    }, "* ", errors[msg]);
  }), /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
    alwaysShowMask: true,
    label: "Telefone",
    placeholder: "+55 (51) 99123-4567",
    mask: "(99) 99999-9999",
    onChange: handleUpdateUser('phone'),
    value: user.phone
  }), ((_errorMsgs$phone = errorMsgs.phone) === null || _errorMsgs$phone === void 0 ? void 0 : _errorMsgs$phone.length) > 0 && errorMsgs.phone.map(function (msg) {
    return /*#__PURE__*/_react["default"].createElement("p", {
      key: msg,
      className: "Auth-right-form-error"
    }, "* ", errors[msg]);
  }), user.type === 'company' ? /*#__PURE__*/_react["default"].createElement(_material.FormControlLabel, {
    label: /*#__PURE__*/_react["default"].createElement("div", {
      className: "Auth-right-checkbox",
      onClick: handleValidForm
    }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("a", {
      href: isFormsCompleted ? '/terms-and-condictions' : '#',
      target: isFormsCompleted ? '_blank' : undefined,
      rel: "noreferrer"
    }, "Termos e condi\xE7\xF5es"), ' ', "&", ' ', /*#__PURE__*/_react["default"].createElement("a", {
      href: "/privacy-policy",
      target: "_blank",
      rel: "noreferrer"
    }, "Politica de Privacidade"))),
    control: /*#__PURE__*/_react["default"].createElement(_material.Checkbox, {
      onChange: function onChange(evt, checked) {
        return setAcceptedTerms(checked);
      },
      checked: acceptedTerms
    })
  }) : null, /*#__PURE__*/_react["default"].createElement(_SimpleButton["default"], {
    fullWidth: true,
    onClick: handleCreateAccount,
    disabled: user.type === 'company' ? !acceptedTerms : false
  }, /*#__PURE__*/_react["default"].createElement("span", null, user.type === 'company' ? 'Criar Conta' : 'Confirmar'), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: "faCheckDouble"
  })));
}
AdminAccount.propTypes = {
  user: _propTypes["default"].shape({
    firstName: _propTypes["default"].string.isRequired,
    lastName: _propTypes["default"].string.isRequired,
    email: _propTypes["default"].string.isRequired,
    phone: _propTypes["default"].string.isRequired,
    type: _propTypes["default"].string.isRequired
  }).isRequired,
  updateUser: _propTypes["default"].func.isRequired,
  goBack: _propTypes["default"].func.isRequired,
  goNext: _propTypes["default"].func.isRequired
};
var _default = AdminAccount;
exports["default"] = _default;
var errors = {
  'first-name-missing': 'Primeiro nome é obrigatório',
  'last-name-missing': 'Último nome é obrigatório',
  'invalid-email': 'Email inválido',
  'email-already-taken': 'Email já está em uso',
  'invalid-phone': 'Telefone inválido'
};